import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { PrintReceipt } from '~/models/administration/printReceipt';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class PrintReceiptsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getPrintReceipt() {
        return this.http.get<PrintReceipt>(this._url());
    }

    updatePrintReceipts(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/PrintReceipts${v}`);
    }
}
